import React from "react";

function TikTokIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#1B1B1B"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#FF004F"
        d="M18.71 10.19v2.267a5.96 5.96 0 01-3.139-1.27v4.58l-.009-.014a4.132 4.132 0 01-4.117 4.404A4.132 4.132 0 017.32 16.03a4.132 4.132 0 014.78-4.076v2.234a1.957 1.957 0 00-2.61 1.842c.001 1.078.878 1.954 1.956 1.954a1.957 1.957 0 001.95-2.075V7.006h2.265l.024.577c.015.377.15.74.384 1.037.275.349.681.754 1.252 1.078a4.29 4.29 0 001.39.494v-.002z"
      ></path>
      <path
        fill="#00F7EF"
        d="M17.932 8.35v2.267a5.958 5.958 0 01-3.139-1.27v4.58l-.01-.014a4.131 4.131 0 01-4.117 4.404 4.131 4.131 0 01-4.125-4.127 4.132 4.132 0 014.78-4.076v2.234a1.957 1.957 0 00-2.61 1.842c.002 1.078.879 1.954 1.956 1.954a1.957 1.957 0 001.95-2.075V5.164h2.265l.024.577c.015.378.15.74.384 1.037.276.35.682.755 1.252 1.078a4.311 4.311 0 001.39.494z"
      ></path>
      <path
        fill="#fff"
        d="M18.427 9.342v2.266a5.957 5.957 0 01-3.139-1.27v4.58l-.01-.013a4.131 4.131 0 01-4.117 4.404 4.131 4.131 0 01-4.125-4.128 4.132 4.132 0 014.78-4.076v2.234a1.957 1.957 0 00-2.61 1.842c.002 1.078.879 1.955 1.956 1.955a1.957 1.957 0 001.95-2.076V6.157h2.265l.024.577c.015.378.15.74.385 1.037.275.35.68.755 1.25 1.079a4.312 4.312 0 001.39.493v-.001z"
      ></path>
    </svg>
  );
}

export default TikTokIcon;
